import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Login from "./Components/Login";
import DashboardLayout from "./Components/DashboardLayout";
import AddDebitor from "./Components/AddDebitor";
import AddCreditor from "./Components/AddCreditor";
import GenerateImage from "./Components/GenerateImage";
import Transactions from "./Components/Transactions";
import DebitorList from "./Components/DebitorList";
import CreditorList from "./Components/CreditorList";
import UpcomingTasks from "./Components/UpcomingTasks";

import "bootstrap/dist/css/bootstrap.min.css";
import "./css/App.css";

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const [debitors, setDebitors] = useState([]);
  const [creditors, setCreditors] = useState([]);

  useEffect(() => {
    if (isLoggedIn) fetchData();
  }, [isLoggedIn]);

  const fetchData = async () => {
    try {
      const [debitorsResponse, creditorsResponse] = await Promise.all([
        fetch("/api/debitors.php"),
        fetch("/api/creditors.php"),
      ]);
      setDebitors(await debitorsResponse.json());
      setCreditors(await creditorsResponse.json());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleLogin = (success) => {
    if (success) {
      sessionStorage.setItem("isLoggedIn", "true");
      setIsLoggedIn(true);
      fetchData();
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
    setDebitors([]);
    setCreditors([]);
  };

  const handleDeleteTable = () => {
    const enteredPassword = prompt("Enter password to delete data:");
    if (enteredPassword === "yourSecretPassword") {
      setDebitors([]);
      setCreditors([]);
      alert("Data deleted successfully!");
    } else {
      alert("Incorrect password. No data deleted.");
    }
  };

  if (!isLoggedIn) return <Login onLogin={handleLogin} />;

  return (
    <Router basename="/">
      <DashboardLayout
        onLogout={handleLogout}
        onDeleteTable={handleDeleteTable}
      >
        <Routes>
          <Route path="/" element={<Navigate to="/viewTransactions" />} />
          <Route path="/viewTransactions" element={<Transactions />} />
          <Route path="/addDebitor" element={<AddDebitor />} />
          <Route
            path="/addCreditor"
            element={
              <AddCreditor
                onCreditorAdded={() => {
                  fetch("/api/creditors.php")
                    .then((res) => res.json())
                    .then((data) => setCreditors(data));
                }}
              />
            }
          />
          <Route
            path="/generateImage"
            element={<GenerateImage debitors={debitors} creditors={creditors} />}
          />
          <Route path="/debitors" element={<DebitorList debitors={debitors} />} />
          <Route path="/creditors" element={<CreditorList creditors={creditors} />} />
          <Route path="/upcomingTasks" element={<UpcomingTasks debitors={debitors} />} />
          <Route path="*" element={<Navigate to="/viewTransactions" />} />
        </Routes>
      </DashboardLayout>
    </Router>
  );
};

export default App;